import { render, staticRenderFns } from "./QuickCommend.vue?vue&type=template&id=d3bb22a6&scoped=true&"
import script from "./QuickCommend.vue?vue&type=script&lang=js&"
export * from "./QuickCommend.vue?vue&type=script&lang=js&"
import style0 from "./QuickCommend.vue?vue&type=style&index=0&id=d3bb22a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3bb22a6",
  null
  
)

export default component.exports